import { patientTabFromParam, type PatientUrlTab, type TabAccess } from './patientTabs';

export type PatientPathTab = 'henvisning' | 'medcom' | 'journal';

/**
 * The tab the patient page should open from the URL: a nested path first
 * (`/henvisning`, `/korrespondance/ny`, `/journal/skriv`), otherwise `?tab=`.
 * This is what PatientDetail uses; `patientTabFromParam` alone is not enough.
 */
export function requestedPatientPageTab(
  pathTab: PatientPathTab | null,
  searchTab: string | null | undefined,
): PatientUrlTab | null {
  return pathTab ?? patientTabFromParam(searchTab);
}

/**
 * Journal and Labsvar share journal view. Until the patient row is loaded that
 * permission is unknown — it must be `pending`, not `false`. A hard `false`
 * makes `resolvePatientTab` treat `?tab=labsvar` as a denied deeplink and drop
 * the request; the next permission update (MedCom connection, clinic settings)
 * then falls back to Aftaler and never restores Labsvar.
 */
export function journalGatedTabAccess(input: {
  patientLoaded: boolean;
  isRelated: boolean;
  canViewJournal: boolean;
}): TabAccess {
  if (!input.patientLoaded) return 'pending';
  return !input.isRelated && input.canViewJournal;
}
